export default class MobileHeader {
    constructor(element) {
        this.selector = element;

        this.openMenu();
        this.closeMenu();
        this.backMenu();
        this.openMenuItem();
        this.handleHomepageHeader();
    }

    openMenu() {
        const buttons = this.selector.querySelectorAll('[data-open]');

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const menu = this.selector.querySelector(`[data-menu="${button.dataset.open}"]`);

                menu.classList.add('active-mobile-menu');
                document.body.classList.add('overflow-hidden');

                if (typeof zE !== 'undefined') {
                    zE('messenger', 'hide');
                }
            });
        });
    }

    closeMenu() {
        const buttons = this.selector.querySelectorAll('[data-close]');

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const menus = this.selector.querySelectorAll('[data-menu]');

                document.body.classList.remove('overflow-hidden');

                menus.forEach((menu) => {
                    menu.classList.remove('active-mobile-menu');
                });

                if (typeof zE !== 'undefined') {
                    zE('messenger', 'show');
                }
            });
        });
    }

    backMenu() {
        const buttons = this.selector.querySelectorAll('[data-back]');

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const menu = button.closest('[data-menu]');
                menu.classList.remove('active-mobile-menu');
            });
        });
    }

    openMenuItem() {
        const items = this.selector.querySelectorAll('[data-menu-item]');

        items.forEach((item) => {
            item.addEventListener('click', () => {
                const menu = item.closest('[data-menu]');
                const container = item.closest('[data-menu-item-container]');
                const content = container.querySelector('[data-menu-item-content]');

                const activeItem = menu.querySelector('[data-menu-item].active');

                item.classList.add('active');
                content.style.maxHeight = `${content.scrollHeight}px`;

                if (!activeItem) {
                    return;
                }

                const activeItemContainer = activeItem.closest('[data-menu-item-container]');
                const activeItemContent = activeItemContainer.querySelector('[data-menu-item-content]');

                activeItem.classList.remove('active');
                activeItemContent.style.maxHeight = 0;
            });
        });
    }

    handleHomepageHeader() {
        if (!this.selector.hasAttribute('data-homepage-header')) return;

        const onScroll = () => {
            if (window.scrollY > 50) {
                this.selector.classList.add('header-scrolled');
            } else {
                this.selector.classList.remove('header-scrolled');
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }
}